import React from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import SignInButton from './SignInButton';
import useUser from '../../hooks/useUser';
import ContractorSignInButton from './ContractorSignInButton';

function SignIn() {
  const isAuthenticated = useIsAuthenticated();
  const user = useUser();

  const onSignInSuccess = (authData) => {
    user.createFromAccount(authData.account);
  }

  return (
    !isAuthenticated 
    ?
      <>
      <ContractorSignInButton/>
      <SignInButton onSuccess={ onSignInSuccess } />
      </>
    :
      null
  );
}

export default SignIn;
